module.exports = __webpack_public_path__ + "img/pleisure_bodyimage05.5aa19f4f.jpg";